import { connect } from 'react-redux'
import MembershipSettings from '../../components/membership-request/MembershipSettings'
import { MembershipUpdateStatus, switchModal } from '../../state/actions/membership_request/'
import { getMemberships, getSelectedMembership, getUpdatingStatus } from '../../state/selectors/'
import { ITemporary } from '../../types'
import { IStoreState } from '../../types/'

export function mapStateToProps(state: IStoreState) {
  return {
    items: getMemberships(state),
    activeRequestType: '',
    selectedMembership: getSelectedMembership(state),
    updatingStatus: getUpdatingStatus(state)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    toggleMembershipModal: () => dispatch(switchModal()),
    MembershipRequestEligibility: (data: ITemporary | string) => dispatch(MembershipUpdateStatus(data))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembershipSettings)



// WEBPACK FOOTER //
// ./src/containers/membership-request/MembershipSettings.ts